import { Component, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import {TranslateModule} from "@ngx-translate/core";

@Component({
  selector: 'lib-loading-page',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: './loading-page.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrl: './loading-page.component.css',
})
export class LoadingPageComponent {}
